// extracted by mini-css-extract-plugin
export default {"center":"GridContainer_center__1Y4bo","side":"GridContainer_side__STSF7"};